<div style="padding:30px">
  <select class="form-control"
    [(ngModel)]="search_model"
    style="width: 120px;display:inline-block"
    (change)="pageobj.page=0;init_list()"
  >
    <option *ngFor="let item of status_option" [ngValue]="item.id">{{item.name}}</option>
  </select>
  <input type="text"  (keyup.enter)="init_list()"  [(ngModel)]="search_str" class="form-control"  style="width: 220px;display:inline-block" placeholder="可輸入電話號碼或暱稱" >

  <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
    <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="ch_menu(item.id)">
      <span [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
    </li>
  </ul>
  <r-table [data]="posts_input" >
    <ng-template let-post #operation_dk>
      <span *ngIf="post.key=='nick' && data.length>0" >
        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
      </span>
      <span *ngIf="post.key=='opt'">
        <a href="javascript:void(0)" title="編輯"  (click)="edit_data=data[post.idx];status_model=data[post.idx].status;why='';tmp_img_b64=''" data-toggle="modal" data-target=".bd-example-modal-xl">
          <i style="margin: 0 10px 0 0;" class="fas fa-file-signature"></i>
        </a>
      </span>
      <span *ngIf="post.key=='status'">
        {{data[post.idx].status==0?'待審核':data[post.idx].status==1?'通過':'未通過'}}
      </span>
      <span *ngIf="post.key=='msg'">
        {{data[post.idx].msg}}
      </span>
    </ng-template>
    <ng-template let-post #operation_mb>
      <span *ngIf="post.key=='nick' && data.length>0" >
        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
      </span>
      <span *ngIf="post.key=='opt'">
        <a href="javascript:void(0)" title="編輯"  (click)="edit_data=data[post.idx];status_model=data[post.idx].status;why='';tmp_img_b64=''" data-toggle="modal" data-target=".bd-example-modal-xl">
          <i style="margin: 0 10px 0 0;" class="fas fa-file-signature"></i>
        </a>
      </span>
      <span *ngIf="post.key=='status'">
        {{data[post.idx].status==0?'待審核':data[post.idx].status==1?'通過':'未通過'}}
      </span>
      <span *ngIf="post.key=='msg'">
        {{data[post.idx].msg}}
      </span>
    </ng-template>
  </r-table>


    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>

</div>
<div
*ngIf="edit_data"
class="modal fade bd-example-modal-xl" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static"
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"

 >
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
          <h4 class="modal-title">審核{{now=='0'?'銀行資料':'kyc認證'}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="now=='0'">
        <div class="flex_text">
          <div class="flext_text_item" >
            <span class="profile_info">身分證本名：{{edit_data.id_name}}</span>
            <span class="profile_info">身分證字號：{{edit_data.id_number}}</span>
            <span class="profile_info">地址：{{edit_data.permanent_addr}}</span>
            <span class="profile_info">通訊地址：{{edit_data.mailing_addr}}</span>
          </div>
          <div class="flext_text_item">
            <span class="profile_info">銀行帳戶：{{edit_data.bank_account}}</span>
            <span class="profile_info">戶名：{{edit_data.bank_accountname}}</span>
            <span class="profile_info">分行：{{edit_data.bank_name}}</span>
            <span class="profile_info">二代健保扣款：
              <button [ngClass]="edit_data.healthy_fee_cn==1?'btn-danger':'btn-secondary'" (click)="edit_data.healthy_fee_cn=1" class="btn" >扣繳</button>
              <button [ngClass]="edit_data.healthy_fee_cn==0?'btn-danger':'btn-secondary'"  (click)="edit_data.healthy_fee_cn=0" class="btn" >不扣繳</button>
            </span>
          </div>
        </div>
        <hr>
        <div class="flex">
          <div class="text_img">
              <div class="card card_fix">
                <img loading="lazy" style="height:15rem" src="{{edit_data.id_card}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title">身分證1</h5>
                  <p class="card-text"></p>
                </div>
              </div>
              <div class="card card_fix">
                <img loading="lazy" style="height:15rem" src="{{edit_data.id_cardback}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title">身分證2</h5>
                  <p class="card-text"></p>
                </div>
              </div>
            <span style="clear:both"></span>
          <div class="card card_fix" >
            <img loading="lazy" style="height:15rem" src="{{edit_data.bank_img}}" class="card-img-top" alt="...">
            <div class="card-body">
              <h5 class="card-title">帳戶圖</h5>
              <p class="card-text"></p>
            </div>
          </div>
          <div class="card card_fix" >
            <img loading="lazy"  *ngIf="edit_data.certified_documents.length>0" (click)="db_ck()" style="height:15rem;cursor: pointer;" src="{{edit_data.certified_documents}}" class="card-img-top" alt="..." >

            <div class="btn btn-info" style="position:relative;margin-left:10px;" *ngIf="edit_data.certified_documents.length==0 && tmp_img_b64.length==0" >
              <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event)"
              placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">官方上傳
            </div>



            <img loading="lazy"  [src]="tmp_img_b64" class="card-img-top"  style="height:15rem;cursor: pointer;"  (click)="tmp_img_b64=''" *ngIf="tmp_img_b64.length>0">
            <div class="card-body">
              <h5 class="card-title">其他證明文件</h5>
              <p class="card-text"></p>
            </div>
          </div>

          </div>
        </div>
      </div>

      <div class="modal-body" *ngIf="now=='1'">
        <div class="">
          <div class="flext_text_item" style="margin-left: 120px;">
            <span class="profile_info">會員名稱：{{edit_data.nick}}</span>
            <span class="profile_info">身分：{{identityName(edit_data.identity)}}</span>
            <span class="profile_info">是否停權：
              <button [ngClass]="edit_data.is_enable==0?'btn-success':'btn-secondary'"  (click)="edit_data.is_enable=0" class="btn" >是</button>
              <button [ngClass]="edit_data.is_enable==1?'btn-success':'btn-secondary'" (click)="edit_data.is_enable=1" class="btn" >否</button>
            </span>
            <span *ngIf="edit_data.is_enable==0" class="profile_info">停權時同步鎖裝置：
              <button [ngClass]="edit_data.lock==1?'btn-success':'btn-secondary'" (click)="edit_data.lock=1" class="btn" >是</button>
              <button [ngClass]="edit_data.lock==0?'btn-success':'btn-secondary'"  (click)="edit_data.lock=0" class="btn" >否</button>
            </span>
            <span class="profile_info">是否潛水：
              <button [ngClass]="edit_data.is_hidden==0?'btn-success':'btn-secondary'"  (click)="edit_data.is_hidden=0" class="btn" >是</button>
              <button [ngClass]="edit_data.is_hidden==1?'btn-success':'btn-secondary'" (click)="edit_data.is_hidden=1" class="btn" >否</button>
            </span>
            <span class="profile_info">是否盜圖：
              <button [ngClass]="edit_data.file_is_enable==6?'btn-success':'btn-secondary'" (click)="edit_data.file_is_enable=6" class="btn" >是</button>
              <button [ngClass]="edit_data.file_is_enable==1?'btn-success':'btn-secondary'" (click)="edit_data.file_is_enable=1" class="btn" >否</button>
            </span>
            <app-check-permissions [data]="'Kus1'">
                <span class="profile_info">推薦分數
                  <input type="range" class="form-range" min="1" max="9" step="1" [(ngModel)]="edit_data.sort_score" >
                  {{edit_data.sort_score}}
                </span>
            </app-check-permissions>
            </div>
        </div>
        <hr>
        <div class="flex" style="max-height:300px">
          <div class="text_img">
              <div class="card card_fix">
                <div class="position-relative">
                    <img loading="lazy" style="height:15rem" src="{{edit_data.pic}}" class="card-img-top" alt="...">
                    <i class="fas fa-times close-icon" (click)="cancel_pic()" *ngIf="search_model == '-1' && now == '1'"></i>
                </div>
                <div class="card-body">
                    <h5 class="card-title">kyc圖片</h5>
                    <p class="card-text"></p>
                </div>

                <div  class="user_edit_block form-group" style="display: flex;padding: 2%;" *ngIf="search_model == '-1' && now == '1'">
                    <label class="col-sm-2 col-form-label custom">kyc圖片</label>
                    <app-img-cropper [editData]="edit_data.pic" (imageUpload)="handleImageUpload($event,0)"></app-img-cropper>
                </div>
              </div>
              <div class="card card_fix">
                <img loading="lazy" style="height:15rem" src="{{edit_data.profile_pic}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title">大頭照</h5>
                  <p class="card-text"></p>
                </div>
              </div>
            <span style="clear:both"></span>
          </div>
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer" style="z-index: 10;">
        <select class="form-control"
                [(ngModel)]="status_model"
				      (ngModelChange)="onStatusChange($event)"
        >

          <option *ngFor="let item of status_option" [ngValue]="item.id" >{{item.name}}</option>
        </select>
          <textarea *ngIf="status_model=='-1'" placeholder="請填寫理由" class="form-control" [(ngModel)]="why"></textarea>
          <button type="button" (click)="submit()"  class="btn btn-primary" data-dismiss="modal">確認</button>
          <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
      </div>
      </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>

